import React, { useEffect, useRef } from 'react';
import { Button, Badge, Modal } from "react-bootstrap";
import idly from '../../../../images/items/idly.png';
import rice_img from '../../../../images/raw_material/rice.png';
import dhal_img from '../../../../images/raw_material/dhal.png';
import fenugreek_img from '../../../../images/raw_material/fenugreek.png';
import salt_img from '../../../../images/raw_material/salt.png';
import red_chilly_img from '../../../../images/raw_material/red_chilly.png';
import black_sesame_img from '../../../../images/raw_material/black_sesame.png';
import cumin_seeds_powder_img from '../../../../images/raw_material/cumin_seeds_powder.png';
import chana_dal_img from '../../../../images/raw_material/chana_dal.png';
import hing_img from '../../../../images/raw_material/hing.png';
import oil_img from '../../../../images/raw_material/oil.png';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
const View = ({ show, onClose }) => {

    const tableRef = useRef(null);
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
   
    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    //   "aaSorting": [],
                    "ordering": false,
                    "paging": false,
                    scrollY: "250px", // Set the scroll height here
                    scrollCollapse: true,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);

    return (
        <Modal show={show} size="lg" >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">View Item</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                    {/* <div>
                        <label>xxx</label>
                    </div> */}
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-2">
                            <div className="d-flex align-items-center">
                                <div className="avatar-preview">
                                    <img
                                        id="saveImageFile"
                                        src={idly}
                                        alt="Raw Material"
                                        className='w-100px h-130px'
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-9">
                            <div className="row mb-2">
                                <label className="col-3 text-black fs-7">Item</label>
                                <label className="col-1 text-black fs-6">:</label>
                                <label className="col-8 text-danger fs-6 fw-bold">Podi Idly</label>
                            </div>
                            <div className="row mb-2">
                                <label className="col-3 text-black fs-7">Category</label>
                                <label className="col-1 text-black fs-6">:</label>
                                <label className="col-8 text-black fs-6">Steamed Food</label>
                            </div>
                            <div className="row mb-2">
                                <label className="col-3 text-black fs-7">Sub Category</label>
                                <label className="col-1 text-black fs-6">:</label>
                                <label className="col-8 text-black fs-6">Idly</label>
                            </div>
                            <div className="row mb-2">
                                <label className="col-3 text-black fs-7">Qty / Units</label>
                                <label className="col-1 text-black fs-6">:</label>
                                <label className="col-8 text-black fs-6">
                                    <Badge bg="success" className='text-white fs-7 py-0 px-1'>
                                       100 No's
                                    </Badge>
                                </label>
                            </div>
                        </div>
                    </div>   
                    <div className='row mt-2'>
                        <div className='col-lg-12 mb-2'>
                            <label className='text-danger fs-3 fw-bold mb-2'>Raw Material</label>
                            <label className='text-black fs-3 fw-bold ms-3 me-3 mb-2'>-</label>
                            <Badge bg="warning" className='text-black fs-4 py-0 px-1'>10</Badge>
                        </div>
                        <div className='col-lg-12 mb-2'>
                            <table ref={tableRef} className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                <thead>
                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                        <th className='min-w-100px text-start'>Raw Material</th>
                                        <th className='min-w-100px'>Category / Sub Category</th>
                                        <th className='min-w-50px'>Qty / Units</th>
                                    </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-semibold fs-7">
                                    <tr>
                                        <td>
                                            <div className="d-flex align-items-center justify-content-start gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={rice_img} className='border rounded px-1 py-0'>
                                                        <img src={rice_img} className='cursor-pointer w-45px h-45px' />
                                                    </div>
                                                </LightGallery>
                                                <div>
                                                    <label className='text-black font-w400 fs-7'>Ponni Rice</label>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>Grains</label>
                                            <div className="d-block">
                                                <label className="fs-8 text-info font-w500">Rice</label>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'> 500 gm's
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="d-flex align-items-center justify-content-start gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={dhal_img} className='border rounded px-1 py-0'>
                                                        <img src={dhal_img} className='cursor-pointer w-45px h-45px' />
                                                    </div>
                                                </LightGallery>
                                                <div>
                                                    <label className='text-black font-w400 fs-7'>Urad Dal</label>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>Grains</label>
                                            <div className="d-block">
                                                <label className="fs-8 text-info font-w500">Pulses</label>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'> 150 gm's
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="d-flex align-items-center justify-content-start gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={fenugreek_img} className='border rounded px-1 py-0'>
                                                        <img src={fenugreek_img} className='cursor-pointer w-45px h-45px' />
                                                    </div>
                                                </LightGallery>
                                                <div>
                                                    <label className='text-black font-w400 fs-7'>Fenugreek</label>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>Grains</label>
                                            <div className="d-block">
                                                <label className="fs-8 text-info font-w500">Pulses</label>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'> 10 gm's
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="d-flex align-items-center justify-content-start gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={salt_img} className='border rounded px-1 py-0'>
                                                        <img src={salt_img} className='cursor-pointer w-45px h-45px' />
                                                    </div>
                                                </LightGallery>
                                                <div>
                                                    <label className='text-black font-w400 fs-7'>Normal Salt</label>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>Seasoning</label>
                                            <div className="d-block">
                                                <label className="fs-8 text-info font-w500">Salt</label>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'> 15 gm's
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="d-flex align-items-center justify-content-start gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={red_chilly_img} className='border rounded px-1 py-0'>
                                                        <img src={red_chilly_img} className='cursor-pointer w-45px h-45px' />
                                                    </div>
                                                </LightGallery>
                                                <div>
                                                    <label className='text-black font-w400 fs-7'>Red Chilli Powder</label>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>Spices</label>
                                            <div className="d-block">
                                                <label className="fs-8 text-info font-w500">Whole Spices</label>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'> 20 gm's
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="d-flex align-items-center justify-content-start gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={black_sesame_img} className='border rounded px-1 py-0'>
                                                        <img src={black_sesame_img} className='cursor-pointer w-45px h-45px' />
                                                    </div>
                                                </LightGallery>
                                                <div>
                                                    <label className='text-black font-w400 fs-7'>Black Seasame Seed</label>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>Nuts</label>
                                            <div className="d-block">
                                                <label className="fs-8 text-info font-w500">Seeds</label>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'> 20 gm's
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="d-flex align-items-center justify-content-start gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={cumin_seeds_powder_img} className='border rounded px-1 py-0'>
                                                        <img src={cumin_seeds_powder_img} className='cursor-pointer w-45px h-45px' />
                                                    </div>
                                                </LightGallery>
                                                <div>
                                                    <label className='text-black font-w400 fs-7'>Cumin Seed</label>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>Spices</label>
                                            <div className="d-block">
                                                <label className="fs-8 text-info font-w500">Whole Spices</label>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'> 07 gm's
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="d-flex align-items-center justify-content-start gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={chana_dal_img} className='border rounded px-1 py-0'>
                                                        <img src={chana_dal_img} className='cursor-pointer w-45px h-45px' />
                                                    </div>
                                                </LightGallery>
                                                <div>
                                                    <label className='text-black font-w400 fs-7'>Chana Dal</label>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>Grains</label>
                                            <div className="d-block">
                                                <label className="fs-8 text-info font-w500">Pulses</label>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'> 20 gm's
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="d-flex align-items-center justify-content-start gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={hing_img} className='border rounded px-1 py-0'>
                                                        <img src={hing_img} className='cursor-pointer w-45px h-45px' />
                                                    </div>
                                                </LightGallery>
                                                <div>
                                                    <label className='text-black font-w400 fs-7'>Hing</label>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>Spices</label>
                                            <div className="d-block">
                                                <label className="fs-8 text-info font-w500">Ground Spices</label>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'> 02 gm's
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="d-flex align-items-center justify-content-start gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={oil_img} className='border rounded px-1 py-0'>
                                                        <img src={oil_img} className='cursor-pointer w-45px h-45px' />
                                                    </div>
                                                </LightGallery>
                                                <div>
                                                    <label className='text-black font-w400 fs-7'>Refinded Oil</label>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'>Liquid</label>
                                            <div className="d-block">
                                                <label className="fs-8 text-info font-w500">Oil</label>
                                            </div>
                                        </td>
                                        <td>
                                            <label className='text-black font-w400 fs-7'> 20 gm's
                                            </label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default View;
